import { Element } from '@thive/canvas';
import { Rectangle } from '@thive/fddm-types';

import { elementFactory } from '@/modules/canvas/factories';
import { FDDM_TAG, INTERACTIVITY_OFF } from '@/modules/floorplanDesign/constants';

const TRANSPARENT_STROKE = { color: '#00000000', width: 0 };

export const createModelAreaRectangleElement = (
  id: string,
  rectangle: Rectangle,
  z: number,
  color: string,
): Element =>
  elementFactory.buildRectangleElement({
    id,
    rectangle,
    z,
    color,
    stroke: TRANSPARENT_STROKE,
    interactivity: INTERACTIVITY_OFF,
    tags: [FDDM_TAG.MODEL],
  });
